export { default } from '@/features/settings/pages/GeneralPage'
